import React from "react";

var convertSvg = function convertSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.985a.994.994 0 0 1 .295-.722L3.283.293a1.01 1.01 0 0 1 1.422 0 .996.996 0 0 1 0 1.414L3.405 3H13a1 1 0 1 1 0 2H3.405l1.3 1.293a.996.996 0 0 1 0 1.414 1.01 1.01 0 0 1-1.422 0L.295 4.737A.994.994 0 0 1 0 3.985zm16 8.03a.994.994 0 0 1-.295.722l-2.988 2.97c-.392.39-1.03.39-1.422 0s-.393-1.024 0-1.414l1.3-1.293H4a1 1 0 0 1 0-2h8.595l-1.3-1.293c-.393-.39-.393-1.024 0-1.414s1.03-.39 1.422 0l2.988 2.97a.994.994 0 0 1 .295.752z",
    fillRule: "evenodd"
  }));
};

convertSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var convert = {
  category: 'icon',
  colorable: true,
  name: 'convert',
  svg: convertSvg
};